// The site's heading face. The owner chose Sora (the Photohawk Personal app's title face, weights 500/600/700) to
// replace Space Grotesk for headings and display text across the whole website; body text stays Inter.
//
// STAGING ONLY until the owner approves it for production. Same switch as the new home page (src/lib/homeFlag.ts):
// the deployment's pinned PHOTOHAWK_ENV, never a visitor's ?phEnv / localStorage override. Where it's on, DefaultMeta
// (src/components/DefaultMeta.tsx) puts data-ph-headings="sora" on <html> and links the Sora stylesheet; the CSS
// (src/index.css, tailwind.config.ts) then resolves the default display face to Sora. Where it's off, nothing is
// rendered and every heading falls back to Space Grotesk exactly as before.
//
// Launch: set SORA_IN_PROD to true in a reviewed PR. Afterwards (cleanup, not needed for the switch): drop
// Space Grotesk from the @import in src/index.css and the "Space Grotesk" fallbacks there and in tailwind.config.ts,
// and regenerate the brand images (scripts/brand-assets) in Sora.

import { deploymentEnv, type DeploymentEnv } from "./homeFlag";
import { useHostname } from "./ssr";

export const SORA_IN_PROD = false;

/** The <html> attribute the CSS keys on (html[data-ph-headings="sora"]). */
export const HEADINGS_ATTR = "data-ph-headings";
export const HEADINGS_SORA = "sora";

/** Sora's weights the site uses, from Google Fonts. */
export const SORA_FONTS_URL = "https://fonts.googleapis.com/css2?family=Sora:wght@500;600;700&display=swap";

/** Whether the Sora headings are on for a deployment env. */
export const soraEnabledFor = (env: DeploymentEnv, inProd: boolean = SORA_IN_PROD): boolean => env !== "prod" || inProd;

/** Whether this deployment shows Sora headings (staging: yes; prod: no until the owner approves them). */
export const isSoraEnabled = (host?: string): boolean => soraEnabledFor(deploymentEnv(host));

/** Whether this page renders with Sora headings (SSR and client agree: both read the deployment's env). */
export const useSoraHeadings = (): boolean => isSoraEnabled(useHostname());

/**
 * Sora-only classes for a page prod also serves. The `sora:` Tailwind variant is enough on staging-only pages, but
 * on a page prod serves today its class names would change prod's HTML, so these are only added where Sora is on.
 */
export const soraOnly = (sora: boolean, classes: string): string => (sora ? ` ${classes}` : "");
